<template>
  <div>
    <a-card v-if="error === false" :loading="spinning">
      <a-page-header v-if="dataSource" :sub-title="`需求详情 # BR-${dataSource.id}`">
        <template slot="title">
          <div style="display: flex">
            {{ dataSource.title || '--' }}
            <!-- <a-tag v-if="flowIsReject" style="line-height: 19px; height: 21px;margin-left: 3px;" color="red">
              驳回
            </a-tag> -->
          </div>
        </template>
        <template slot="extra">
          <BusinessRequirementAction v-if="type !== 'retrospect'" ref="businessRequirementActionRef" :br-type="dataSource.type" :data-source="dataSource" :next-status="dataSource.nextStatus" @ok="getStoryDetail" @readBrOk="readBrOk" @brClaimOk="brClaimOk" />
        </template>
        <a-descriptions size="small" :column="4">
          <a-descriptions-item v-if="type !== 'retrospect'" label="状态">
            <StatusTag :status="dataSource.status" :br-type="dataSource.type" />
            <!-- <status-edit :source-id="dataSource.id" :status="dataSource.status" :next-status="dataSource.nextStatus" @ok="getStoryDetail" /> -->
          </a-descriptions-item>
          <a-descriptions-item v-if="dataSource.type !== 21" label="需求分类">
            <span v-if="requirementType.find(item => dataSource.requirementType === item.value)">
              {{ requirementType.find(item => dataSource.requirementType === item.value).label }}
              <a-popover v-if="requirementType.find(item => dataSource.requirementType === item.value).tips" placement="top">
                <template slot="content">
                  <span>{{ requirementType.find(item => dataSource.requirementType === item.value).tips }}</span>
                </template>
                <a-icon style="cursor: pointer" type="question-circle" />
              </a-popover>
            </span>
            <span v-else> -- </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="dataSource.type === 21" label="需求分类">
            <span v-if="bigBrType.find(item => dataSource.bigBrType === item.value)">
              {{ bigBrType.find(item => dataSource.bigBrType === item.value).label }}
              <a-popover v-if="bigBrType.find(item => dataSource.bigBrType === item.value).tips" placement="top">
                <template slot="content">
                  <span>{{ bigBrType.find(item => dataSource.bigBrType === item.value).tips }}</span>
                </template>
                <a-icon style="cursor: pointer" type="question-circle" />
              </a-popover>
            </span>
            <span v-else> -- </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="dataSource.type !== 21" label="需求打分">
            <span>
              <span v-if="requirementScoreTitle(dataSource.score)">
                {{ requirementScoreTitle(dataSource.score).label }}
                <a-popover placement="top">
                  <template slot="content">
                    <span>{{ requirementScoreTitle(dataSource.score).tips }}</span>
                  </template>
                  <a-icon style="cursor: pointer" type="question-circle" />
                </a-popover>
              </span>
              <span v-else> -- </span>
            </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="type !== 'retrospect' && dataSource.type !== 21" label="需求目的">
            <span>
              {{ requirementTarget.find(item => dataSource.target === item.value) ? requirementTarget.find(item => dataSource.target === item.value).label : '--' }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="dataSource.type === 21" label="需求主题">
            <span>
              {{ requirementSubject.find(item => dataSource.target === item.value) ? requirementSubject.find(item => dataSource.target === item.value).label : '--' }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="type !== 'retrospect' && dataSource.type !== 21" label="涉及产品线">
            <span>
              {{ getProductLines(dataSource.productLine) }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="type !== 'retrospect'" label="创建人">
            <span>{{ getUserName(dataSource.creator) }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="主业务方">
            <span>{{ getUserName(dataSource.businessPartner) }}</span>
          </a-descriptions-item>
          <a-descriptions-item v-if="type !== 'retrospect'" label="业务部门">
            <span>
              {{ businessDepartment.find(item => dataSource.businessDepartment === item.value) ? businessDepartment.find(item => dataSource.businessDepartment === item.value).label : '--' }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="type !== 'retrospect' && dataSource.type !== 21" label="关联业务方">
            <span>
              {{ getUserNames(dataSource.businessCorrelation) }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="dataSource.type !== 21" label="产品运营">
            <span>
              {{ getUserNames(dataSource.productOperation) }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="type !== 'retrospect' && dataSource.type !== 21" label="技术经理">
            <span>
              {{ getUserNames(dataSource.technicalManager) }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="type !== 'retrospect'" label="期望上线时间">{{ dataSource.expectTime || '--' }}</a-descriptions-item>
          <a-descriptions-item v-if="type !== 'retrospect' && dataSource.type !== 21" label="预计上线时间">{{ dataSource.planOnlineTime || '--' }}</a-descriptions-item>
          <a-descriptions-item v-if="type !== 'retrospect'" :label="dataSource.type !== 21 ? '产品PO' : '数据分析师'">
            <span>
              {{ getUserNames(dataSource.po) }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="dataSource.type !== 21" label="相关产品">
            <span>
              {{ getUserNames(dataSource.relatedProduct) }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="false && dataSource.status >= 134 && type !== 'retrospect'" label="需求设计状态">
            <BrDesignStatusEdit :r-status="dataSource.status" :source-id="dataSource.id" :status="dataSource.designStatus" @change="getStoryDetail" />
          </a-descriptions-item>
          <a-descriptions-item v-if="dataSource.status >= 134 && type !== 'retrospect' && dataSource.type !== 21" label="需求计划完成时间">
            <BrPlanTimeEdit :r-status="dataSource.status" :source-id="dataSource.id" :data-source="dataSource" @change="getStoryDetail" />
          </a-descriptions-item>
          <a-descriptions-item label="优先级">
            <span>
              {{ getPriorityNames(dataSource.priority) }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item label="业务需求点数">
            <span v-if="dataSource.point"> {{ dataSource.point }} BRP </span>
            <span v-else> -- </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="type !== 'retrospect' && dataSource.type !== 21" label="关联项目">
            <span>
              {{ getRelatedProjectNames(dataSource.relatedProject) }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="type === 'retrospect'" label="追溯类型">
            <span>
              {{ getRetrospectTypeText(dataSource.retrospectType) }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="false" label="厂长制">
            <span v-if="!dataSource.isFactoryModel">否</span>
            <span v-if="dataSource.isFactoryModel">是</span>
          </a-descriptions-item>
          <a-descriptions-item v-if="false && dataSource.isFactoryModel" label="结算方式">
            <span>
              {{ settlementModel.find(item => dataSource.settlementModel === item.value) ? settlementModel.find(item => dataSource.settlementModel === item.value).label : '--' }}
            </span>
          </a-descriptions-item>
        </a-descriptions>
      </a-page-header>
      <a-tabs v-model="tabsCurrent" default-active-key="1" size="small" @change="handleTabsChange">
        <a-tab-pane key="0" :tab="type === 'retrospect' ? '需求追溯' : '详细信息'">
          <Review v-if="type !== 'retrospect'" ref="reviewRef" :br-type="dataSource.type" :data-source="dataSource" @onReload="getStoryDetail" @changeIsReject="item => (flowIsReject = item)" />
          <BrRetrospect v-if="type === 'retrospect'" :br-data="dataSource" />
        </a-tab-pane>
        <!-- <a-tab-pane key="1">
          <span slot="tab">详细信息</span>
          <div style="font-size: 15px; font-weight: 600; margin-bottom: 8px">附件</div>
          <a-empty v-if="(!dataSource.files || dataSource.files.length == 0) && (!dataSource.images || dataSource.images.length == 0)" description="暂无附件" />
          <UploadImg :is-edit="false" :data-list="dataSource.images" />
          <UploadFile style="margin-top: 10px" :is-edit="false" :data-list="dataSource.files" />
          <comment-panel mode="business_requirement" :active-key="[]" :source-id="dataSource.id" />
        </a-tab-pane> -->
        <a-tab-pane v-if="dataSource.status > 130 && type !== 'retrospect'" key="2">
          <span slot="tab">关联MRD </span>
          <!-- 仅待关联MRD、MRD撰写中、MRD评审中、待关联需求展示关联按钮 -->
          <!-- <a-space v-if="[2, 3, 4].includes(dataSource.status)" style="margin-bottom: 8px; display: flex; justify-content: end">
            <a-button @click="onAssociate()">关联MRD</a-button>
            <a-button icon="plus" type="primary" @click="onAddDocument()">添加MRD</a-button>
          </a-space>
          <document-list :data-source="dataSource.documents" :user-data="userData" /> -->
          <mrd-info :source-id="requirementId" :data-source="dataSource.documents" :status="dataSource.status" @reload="getStoryDetail" />
        </a-tab-pane>
        <a-tab-pane v-if="dataSource.status >= 135 && type !== 'retrospect' && dataSource.type != 21" key="3">
          <span slot="tab">关联产研需求 ({{ requirementData ? requirementData.length : 0 }})</span>
          <a-space v-if="[135, 136, 137, 149].includes(dataSource.status)" style="margin-bottom: 8px; display: flex; justify-content: end">
            <a-button v-tc="{ name: '关联产研需求' }" @click="onAssociateRequirement()">关联产研需求</a-button>
            <a-button v-tc="{ name: '添加产研需求' }" icon="plus" type="primary" @click="onAddRequirement()">添加产研需求</a-button>
          </a-space>
          <requirement-list :data-source="requirementData" />
        </a-tab-pane>
        <a-tab-pane key="4" tab="变更历史">
          <Changelog v-if="type !== 'retrospect'" ref="changelog" :source-id="dataSource.id" />
          <RetrospectChangelog v-else ref="retrospectChangelog" :source-id="dataSource.id" />
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <a-card v-else>
      <a-result status="403" title="403" sub-title="没有权限访问该文档">
        <template #extra>
          <a-button type="primary" @click="onBack"> 返回列表 </a-button>
        </template>
      </a-result>
    </a-card>
    <document-edit ref="documentEditRef" @ok="getStoryDetail" />
    <associate-document ref="associateDocumentRef" @saveOK="getStoryDetail" />
    <associate-requirement ref="associateRequirementRef" @ok="getStoryDetail" />
    <story-edit-drawer ref="storyEditDrawerRef" source-type="business_requirement" @ok="getStoryDetail" />
  </div>
</template>
<script>
import { userList } from '@/api/system/auth';
import { storySearch } from '@/api/project/story';
import { tagList } from '@/api/system/tag';
import { getBusinessRequirement } from '@/api/business/requirement';
import { requirementScore, requirementTarget, settlementModel, requirementType, productLine, brPriority, retrospectType, bigBrType, requirementSubject } from '@/utils/dictionary';
import Changelog from '@/pages/business/requirement/components/Changelog';
import DocumentEdit from '@/pages/business/document/components/DocumentEdit';
import StoryEditDrawer from '@/pages/project/story/components/StoryEditDrawer';
import RequirementList from '@/pages/project/story/components/RequirementList';
// import DocumentList from '@/pages/business/requirement/components/DocumentList';
import AssociateDocument from '@/pages/business/requirement/components/AssociateDocument';
import AssociateRequirement from '@/pages/business/requirement/components/AssociateRequirement';
import BusinessRequirementAction from '@/pages/business/requirement/components/BusinessRequirementAction';
import Review from '@/pages/business/requirement/components/Review';
import StatusTag from '@/pages/business/requirement/components/StatusTag';
import MrdInfo from '@/pages/business/requirement/components/MrdInfo';
import BrDesignStatusEdit from '@/pages/business/requirement/components/BrDesignStatusEdit';
import BrPlanTimeEdit from '@/pages/business/requirement/components/BrPlanTimeEdit';
import BrRetrospect from '@/pages/business/requirement/components/BrRetrospect';
import RetrospectChangelog from '@/pages/business/requirement/components/RetrospectChangelog';

export default {
  components: {
    BrRetrospect,
    BrDesignStatusEdit,
    BrPlanTimeEdit,
    MrdInfo,
    StatusTag,
    Review,
    // UploadImg,
    // UploadFile,
    // CommentPanel,
    Changelog,
    // DocumentList,
    DocumentEdit,
    RequirementList,
    StoryEditDrawer,
    AssociateDocument,
    AssociateRequirement,
    BusinessRequirementAction,
    RetrospectChangelog
  },
  data() {
    return {
      bigBrType,
      requirementSubject,
      retrospectType,
      brPriority,
      requirementScore,
      requirementTarget,
      settlementModel,
      requirementType,
      productLine,
      spinning: false,
      loading: false,
      error: false,
      projectId: parseInt(this.$route.params.project_id) || null,
      requirementId: parseInt(this.$route.params.id) || null,
      dataSource: {},
      requirementData: [],
      userData: [],
      tabsCurrent: '0',
      flowIsReject: false,
      brProjects: []
    };
  },
  computed: {
    type() {
      const _path = this.$route.path;
      if (_path.indexOf('retrospect') > -1) {
        return 'retrospect';
      }
      return 'br';
    },
    businessDepartment() {
      return this.$store.getters.globalConfig('business_department', []);
    },
    requirementScoreTitle() {
      return value => {
        const el = requirementScore.find(item => value === item.value);
        if (el) {
          // return `${el.label}(${el.tips})`;
          return el;
        }
        return null;
      };
    },
    users() {
      return items => {
        return items || [];
      };
    }
  },

  created() {
    this.getUserList();
    this.getStoryDetail(true);
    this.getTagList();
  },
  methods: {
    getRetrospectTypeText(_retrospectType) {
      if (!_retrospectType || _retrospectType.length === 0) {
        return '--';
      }
      let text = '';
      _retrospectType.forEach((item, index) => {
        const obj = retrospectType.find(i => i.value === item);
        if (obj) {
          text += obj.label + ',';
        }
      });
      return text;
    },
    onAssociate() {
      this.$refs.associateDocumentRef.onOpen(this.dataSource.id);
    },
    init(record) {
      this.dataSource = record;
      this.getStoryDetail();
    },
    getPriorityNames(id) {
      const obj = this.brPriority.find(item => item.value === id);
      return obj ? obj.label : '--';
    },
    getRelatedProjectNames(ids) {
      if (ids && ids.length > 0 && this.brProjects) {
        return this.brProjects
          .filter(item => ids.includes(item.id))
          .map(item => item.name)
          .join('、');
      }
      return '--';
    },
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users;
      });
    },
    getTagList() {
      tagList({ group_code: 'br_project' }).then(res => {
        this.brProjects = res.data.items || [];
      });
    },
    getUserNames(list) {
      if (!list) return '--';
      return list.map(item => this.getUserName(item)).join('、');
    },
    getProductLines(list) {
      if (!list) return '--';
      return list
        .map(item => {
          return this.getProductLine(item);
        })
        .join('、');
    },
    getProductLine(id) {
      const __data = this.productLine.find(item => id === item.value);
      if (__data) {
        return __data.label;
      }
      return null;
    },
    getUserName(userId) {
      const user = this.userData.find(item => item.id === userId);
      if (user) {
        return user.nickname || '--';
      } else {
        return '--';
      }
    },
    brClaimOk(brClaimInfo) {
      this.dataSource.claimant = brClaimInfo.userId;
      this.dataSource.claimTeam = brClaimInfo.teamList;
      this.dataSource.lastQaTime = '';
    },
    readBrOk() {
      this.dataSource.read = true;
    },
    /**
     * 获取需求详情
     */
    getStoryDetail(isInit) {
      getBusinessRequirement({ id: this.requirementId, project_id: this.projectId })
        .then(res => {
          this.dataSource = res.data;
          this.spinning = false;
          if (this.type !== 'retrospect') {
            this.$refs.reviewRef.init(this.dataSource.flowId);
            this.$refs.businessRequirementActionRef.getReviewInfo(this.dataSource.id);
            if (isInit && [131, 134, 151].includes(this.dataSource.status)) {
              // 初始化时，如果状态为MRD进行中，则自动锚点到关联MRD中
              this.tabsCurrent = '2';
            }
          }
        })
        .catch(() => {
          this.error = true;
          this.spinning = false;
        });
      this.getRequirementList();
    },

    /**
     * 获取关联产研需求列表
     */
    getRequirementList() {
      storySearch({ business_requirement: this.requirementId }).then(res => {
        this.requirementData = res.data.items;
      });
    },

    handleTabsChange(key) {
      this.tabsCurrent = key;
      let lable = '';
      if (key === '0') {
        lable = this.type === 'retrospect' ? '需求追溯' : '详细信息';
      } else if (key === '2') {
        lable = '关联MRD';
      } else if (key === '3') {
        lable = '关联产研需求';
      } else if (key === '4') {
        lable = '变更历史';
      }
      if (lable) {
        this.utils.trackClick({ name: '点击TABS', lable: lable });
      }
    },

    /**
     * 点击添加MRD
     */
    onAddDocument() {
      this.$nextTick(() => {
        this.$refs.documentEditRef.onOpen(this.requirementId);
      });
    },

    /**
     * 添加产研需求
     */
    onAddRequirement() {
      this.$nextTick(() => {
        this.$refs.storyEditDrawerRef.onOpen(null, { business_requirements: [{ id: this.requirementId, title: this.dataSource.title }] });
      });
    },

    /**
     * 添加产研需求
     */
    onAssociateRequirement() {
      this.$nextTick(() => {
        this.$refs.associateRequirementRef.onOpen(this.requirementId);
      });
    },

    /**
     * 返回业务需求列表
     */
    onBack() {
      this.$router.push({ name: 'page:business:requirement' });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-card-body {
  position: relative;
  padding: 16px 16px 40px;

  .ant-page-header {
    padding: 0;
  }

  .ant-tabs-nav .ant-tabs-tab {
    margin: 0 8px 0 0;
  }
}
</style>
